// src/pages/SubscriptionSuccessPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "../components/ui/button";
import { CheckCircle, ArrowRight, RefreshCw } from "lucide-react";
import { motion } from "framer-motion";

const SubscriptionSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-4">
      <Helmet>
        <title>Subscription Active — AI Workshop LLC</title>
      </Helmet>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-md w-full text-center"
      >
        <div className="w-20 h-20 rounded-full bg-blue-500/20 border border-blue-500/40 flex items-center justify-center mx-auto mb-8">
          <CheckCircle className="w-10 h-10 text-[#3b82f6]" />
        </div>
        <h1 className="text-4xl font-black text-white mb-4">You're subscribed!</h1>
        <p className="text-slate-400 text-lg mb-3 leading-relaxed">
          Your AI Implementation OS is now active.
        </p>
        <div className="bg-slate-900/70 backdrop-blur-xl border border-white/10 rounded-2xl p-6 mb-8 text-left space-y-3">
          {[
            "Your tool recommendations will auto-update weekly",
            "First weekly digest arrives next Monday",
            "Progress tracking now syncs to your account",
          ].map((item) => (
            <div key={item} className="flex items-start gap-3">
              <RefreshCw className="w-4 h-4 text-[#3b82f6] flex-shrink-0 mt-0.5" />
              <span className="text-slate-300 text-sm">{item}</span>
            </div>
          ))}
        </div>
        <Button
          onClick={() => navigate("/my-reports")}
          className="w-full bg-gradient-to-br from-[#3b82f6] to-blue-500 hover:shadow-blue-500/30 text-slate-950 font-black text-base py-4 rounded-full"
        >
          View My Reports <ArrowRight className="w-4 h-4 ml-2 inline" />
        </Button>
      </motion.div>
    </div>
  );
};

export default SubscriptionSuccessPage;
